'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.getQuerySet = getQuerySet;
exports.getQueryParam = getQueryParam;
exports.getHash = getHash;
exports.mergeQueryParam = mergeQueryParam;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var href = void 0,
    search = void 0,
    hash = void 0,
    params = '';

function getQuerySet() {
  initQueryStr();

  var queryStr = void 0;

  if (search) {
    queryStr = getSearchFromHref();
  } else if (!!~hash.indexOf('?')) {
    queryStr = hash.split('?')[1];
  }

  if (!queryStr) {
    return params = {};
  }

  params = getParamsFromQuery(queryStr);

  return params;
}

function getQueryParam(key) {

  if (!key) {
    return null;
  }

  getQuerySet();

  return params[key];
}

function getHash() {
  initQueryStr();

  var _hash = hash.substr(1);

  if (hash) {
    var hashArray = _hash.split('?');
    return hashArray[0];
  } else {
    return '';
  }
}

function mergeQueryParam(params) {
  var autoJump = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var newParms = {};
  var oldParms = getQuerySet();
  var _hash = getHash();

  if (~href.indexOf('?')) {
    newParms = (0, _extends3.default)({}, oldParms, params);
    href = href.split('?')[0];
  } else {
    newParms = params;
  }

  href += '?';

  for (var i in newParms) {
    if (newParms.hasOwnProperty(i)) {
      href += i + '=' + newParms[i] + '&';
    }
  }

  href = href.substring(0, href.length - 1);

  if (_hash) {
    href += '#' + _hash;
  }

  if (location && autoJump) {
    location.href = href;
  }

  return href;
}

function getParamsFromQuery(str) {
  var params = {};
  var paramsArray = str.split('&');

  paramsArray.forEach(function (item) {
    var itemArray = item ? item.split('=') : null;

    if (itemArray && !params[itemArray[0]]) {
      params[itemArray[0]] = itemArray[1] ? decodeURIComponent(itemArray[1]) : '';
    }
  });

  return params;
}

function getSearchFromHref() {
  var serchStr = '';

  if (search) {
    serchStr = search.substr(1);
  }

  var partialSearch = href.split('?')[2];
  if (partialSearch) {
    serchStr += '&' + partialSearch;
  }

  return serchStr;
}

function initQueryStr() {
  if (!window) {
    return;
  }
  href = window.location.href;
  search = window.location.search;
  hash = window.location.hash;
  params = '';
}

window.addEventListener('hashchange', function () {
  initQueryStr();
});

initQueryStr();